/* unplugin-vue-components disabled */import script from "./PreparedPropCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PreparedPropCard.vue?vue&type=script&setup=true&lang=js"

import "./PreparedPropCard.vue?vue&type=style&index=0&id=626d8fb8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626d8fb8"]])

export default __exports__